import React, { forwardRef, useRef, ForwardedRef } from 'react'
import { useNotification } from '../../utils/hooks'
import { NotificationType } from '../Notification'

interface IProps {
  onChange: (file: File) => void
  id?: string
  name?: string
  className?: string
  accept?: string
  maxSizeMB?: number
}

export const FileInput = forwardRef<HTMLInputElement, IProps>(
  (
    {
      id,
      name,
      className,
      onChange,
      accept = 'application/pdf',
      maxSizeMB = 50,
    },
    ref,
  ) => {
    const { addNotification } = useNotification()
    const localFileInputRef = useRef<HTMLInputElement>(null)

    // Use provided ref or local ref
    const fileInputRef = ref || localFileInputRef

    const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files && event.target.files[0]

      if (!file) return

      if (file.size > maxSizeMB * 1024 * 1024) {
        addNotification(
          `File size exceeds ${maxSizeMB}MB limit.`,
          NotificationType.error,
        )
        return
      }

      onChange(file)
    }

    return (
      <input
        id={id}
        name={name}
        type='file'
        accept={accept}
        ref={fileInputRef as ForwardedRef<HTMLInputElement>}
        className={className}
        onChange={onFileChange}
      />
    )
  },
)
